'use client';

import { MockAuthProvider } from './auth/MockAuthProvider';

export function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <MockAuthProvider>
      {children}
    </MockAuthProvider>
  );
}